import React from "react";
import "./SupportSection.css";

const SupportSection = () => {

  const data = [
    {
      number: "01",
      title: "Expert Instructors",
      image: "/images/Instructors1.webp",
      alt: "Students attending practical IT training at PRT Academy Hyderabad",
      desc:
        "Learn from experienced instructors through structured, practical and mentor-led training.",
      icon: "🎓"
    },

    {
      number: "02",
      title: "1:1 Mentorship",
      image: "/images/Mentors1.webp",
      alt: "Students receiving software development mentorship at PRT Academy",
      desc:
        "Get personalised guidance, coding support and feedback to improve your technical skills.",
      icon: "🤝"
    },

    {
      number: "03",
      title: "Career & Placement Support",
      image: "/images/Learning1.webp",
      alt: "PRT Academy students receiving career and placement guidance",
      desc:
        "Get continuous career guidance, interview preparation and support throughout your learning journey.",
      icon: "🚀"
    }
  ];

  return (
    <section className="support-container">

      {/* ================= HEADER ================= */}

      <div className="support-header">

        <span className="support-badge">
          WHY PRT ACADEMY
        </span>

        <h2 className="heading">
          Learn With the Support You Need to{" "}
          <span>Build Your Career</span>
        </h2>

        <p className="support-intro">
          At PRT Academy, learning goes beyond classroom training.
          Students receive practical guidance, mentorship and career
          support throughout their journey.
        </p>

      </div>


      {/* ================= USP CARDS ================= */}

      <div className="card-container">

        {data.map((item) => (

          <article
            className="support-card"
            key={item.number}
          >

            {/* IMAGE */}

            <div className="video-wrapper">

              <img
                src={item.image}
                alt={item.alt}
                className="support-image"
              />

              <span className="support-number">
                {item.number}
              </span>

            </div>


            {/* CONTENT */}

            <div className="support-card-content">

              <div className="support-icon">
                {item.icon}
              </div>

              <h3>
                {item.title}
              </h3>

              <p>
                {item.desc}
              </p>

            </div>

          </article>

        ))}

      </div>


      {/* ================= BOTTOM MESSAGE ================= */}

      <div className="support-bottom">

        <div>

          <span>
            PRT ACADEMY
          </span>

          <h3>
            Learn With Guidance.
            <strong> Grow With Confidence.</strong>
          </h3>

        </div>

        <p>
          Practical training, personalised mentorship and career support
          help students move from learning to professional readiness.
        </p>

      </div>

    </section>
  );
};

export default SupportSection;